'use strict'

define ['./signup.css'], () ->
  ($scope, $rootScope, $state, Flash, RentappService, $localStorage,  $stateParams, $cookies, $location, $anchorScroll, $http, RENTAPPLICATION_API_URL) ->
    
    LogRocket = require('logrocket')
    $scope.user_types = [
      {'label': "brokerage", 'value': "Agency / Brokerage or Real Estate Professional"}, 
      {'label': "property_manager", 'value': "Property Manager"}, 
      {'label': "landlord", 'value': "Independent Landlord"}, 
    ]
    $scope.referrer_info = null
    $scope.referrer_name = ""

    $scope.update_user_type = (type) ->
      $scope.user_type = type

    $scope.close_error = () ->
      $scope.error_message = null
    
    $scope.load_referrer = (referrer_name) ->
      $http.get "#{RENTAPPLICATION_API_URL}/api/v3/referrers/#{referrer_name}"
        .then (resp) ->
          $scope.referrer_info = resp.data

          if not $localStorage.ambassador
            ambassador_data = resp.data
            ambassador_data.expire_at = moment().add(30, 'days').format()
            $localStorage.ambassador = JSON.stringify(resp.data)
          
          Flash.create("success", """
            <span style="font-size: 22px;"><strong>#{$scope.referrer_info.landlord_name or $scope.referrer_info.username} invited you to Rent Application!</strong></span><br><br>
            <span style="font-size: 12px;">Reduce risk and find high quality tenants with Rent Application's optimized process.</span>
          """, 0, {class: "affiliate-promo"}, true)
        .catch (err) ->
          console.log(err)

    if $localStorage.apply_app_slug
      $scope.apply_app_slug = $localStorage.apply_app_slug
      Flash.create("danger", """
        Looks like you are an applicant. Click <a ui-sref="root.applications.apply({application_slug:'#{$scope.apply_app_slug}'})">here</a> to go back to your application
      """, 30000, {}, true)
    
    # if $localStorage.ambassador
    #   $scope.ambassador = $localStorage.ambassador.

    if $stateParams.referrer_name
      $scope.referrer_name = $stateParams.referrer_name
      $scope.load_referrer($stateParams.referrer_name)

    else if $localStorage.ambassador
      ambassador = JSON.parse($localStorage.ambassador)
      
      if moment().isBefore(ambassador.expire_at)
        $scope.referrer_name = ambassador.name
        $scope.load_referrer(ambassador.name)
      else
        $localStorage.ambassador = null
  
    $scope.signup = (username, password1, full_name, comp_name) ->
      if !$scope.user_type
        $scope.error_message = ["Please select the account type"]
        return
      $scope.signing_up = true
      RentappService.register(username, password1, {
        'full_name': full_name,
        "user_type": $scope.user_type.label,
        'comp_name' : comp_name,
        "referrer_name": $scope.referrer_name or $stateParams.referrer_name,
        "referrer_data":
          "ORIGINAL_HTTP_REFERER": $cookies.get('ORIGINAL_HTTP_REFERER')
          "ORIGINAL_ENTRY_PAGE": $cookies.get('ORIGINAL_ENTRY_PAGE')
      })
      .then (response) ->
        $cookies.put("just_signed_up", true)

        dataLayer = window.dataLayer = window.dataLayer || []

        dataLayer.push (
          'event': 'new_signup'
          'newSignupID': response.data.userId
        )

        if $rootScope.LOGROCKET_ID
          LogRocket.identify(response.data.user.username, response.data.user)

        RentappService.login(username, password1).then () ->
          $rootScope.$broadcast("landlord-conversion", { user_id: response.data.userId, user_email: response.data.user })
          $state.go "root.dashboard.forms"

      .catch (error) ->
        $scope.error_message = _.reduce(error.data, (result, value, key) ->
          result = _.concat(result, value)
          return result
        )
        $location.hash('error_message')
        $anchorScroll()

      .finally ->
        $scope.signing_up = false



// WEBPACK FOOTER //
// ./components/home/signup/signup.coffee